import { Heading, Icon, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { AppointmentName } from '@eluve/smart-blocks';

export const PlayingDisclaimer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Stack className="pt-4" gap={8} justify="stretch">
      <AppointmentName readonly />
      <Stack
        align="center"
        justify="center"
        className="h-[240px] rounded-lg bg-bg-tertiary"
      >
        <Stack
          align="center"
          justify="center"
          fullWidth={false}
          className="rounded-full bg-text-accent-primary p-4"
        >
          <Icon name="Volume2" size="xl" className="size-14 text-white" />
        </Stack>
      </Stack>
      <Heading size="lg" weight="bold" level={2} className="lg:text-[28px]">
        {t('appointmentPage.disclaimer')}
      </Heading>
      <Text size="md">[Disclaimer transcript goes here.]</Text>
    </Stack>
  );
};
